<div class="form-setup" *ngIf="version && !nonConfigurableQuestionProcesses.includes(version?.type)">
  <div class="form-setup-title">
    <h2>{{ 'manageVersion.configForm' | translate }}</h2>
    <ion-button *ngIf="!questionGroupsAvailable() && !managerQuestionGroupsAvailable()" mode="ios" color="secondary"
      (click)="addQuestion()" [disabled]="!version">
      {{ 'manageVersion.addQuestion' | translate }}
    </ion-button>
    <ion-button *ngIf="questionGroupsAvailable()" mode="ios" color="secondary"
      (click)="addQuestionGroup(managerQuestionGroupsSelected)" [disabled]="!version">
      {{ 'manageVersion.addQuestionGroup' | translate }}
    </ion-button>
  </div>

  <ng-container *ngIf="version?.type === ProcessType.GoalInputs">
    <div class="consent">
      <ion-row class="consent-goals">
        <ion-col>
          <ion-row class="consent-toggle">
            <ion-toggle [ngModel]="version?.goalType" (ionChange)="changeGoalType($event)"></ion-toggle>
            <span>{{ 'goals.enableConsentGoals' | translate }}</span>
          </ion-row>

          <ion-row>
            <div class="consent-goals-modal" (click)="this.version?.goalType ? openGoalConsentModal() : null">
              {{ 'goals.consentGoals' | translate }}

              <div class="consent-goals-length">{{ this.version?.consentGoals ?
                this.version?.consentGoals?.length : 0 }}</div>
            </div>
          </ion-row>
        </ion-col>
        <ion-col class="consent-modal-attributes">
          <div (click)="this.version?.goalType ? manageAttributes() : null" class="manage-attributes consent-attributes"
            margin-start>
            <span> {{ version?.consentAttributes ? version?.consentAttributes.length : 0 }} {{
              'generic.attributes' | translate | uppercase }} </span>
            <ion-icon class="bp-setting" name="settingsCog"></ion-icon>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </ng-container>

  <div class="container-questions" *ngIf="version && !questionGroupsAvailable()">
    <ng-container *ngFor="let question of version?.questions;">
      <ng-container [ngSwitch]="selectedLanguage">
        <app-question-configuration *ngSwitchCase="'pt-BR'" [question]="question" [version]="version"
          [questionTypeConfigs]="version?.questionTypeConfigs" [language]="'pt-BR'"
          (deleteQuestion)="deleteQuestion($event)" (reorderQuestions)="reorderQuestions($event)"
          (updateQuestionTypeConfig)="updateQuestionTypeConfig($event)"></app-question-configuration>

        <app-question-configuration *ngSwitchCase="'en-US'" [question]="question" [version]="version"
          [questionTypeConfigs]="version?.questionTypeConfigs" [language]="'en-US'"
          (deleteQuestion)="deleteQuestion($event)" (reorderQuestions)="reorderQuestions($event)"
          (updateQuestionTypeConfig)="updateQuestionTypeConfig($event)"></app-question-configuration>

        <app-question-configuration *ngSwitchCase="'es-ES'" [question]="question" [version]="version"
          [questionTypeConfigs]="version?.questionTypeConfigs" [language]="'es-ES'"
          (deleteQuestion)="deleteQuestion($event)" (reorderQuestions)="reorderQuestions($event)"
          (updateQuestionTypeConfig)="updateQuestionTypeConfig($event)"></app-question-configuration>
      </ng-container>
    </ng-container>
  </div>

  <div class="container-question-groups" *ngIf="questionGroupsAvailable() && !managerQuestionGroupsSelected">
    <ng-container *ngFor="let question of version?.questionGroups">
      <ng-container [ngSwitch]="selectedLanguage">
        <app-question-group *ngSwitchCase="'pt-BR'" [version]="version" [group]="question"
          [questionTypeConfigs]="version?.questionTypeConfigs" [language]="'pt-BR'"
          [groupsSelectItems]="groupsSelectItems" (addQuestion)="addQuestion($event)"
          (changeGroupFromQuestion)="groupFromQuestionChanged($event)" (moveUpGroup)="moveUpGroup($event)"
          (moveDownGroup)="moveDownGroup($event)"
          (removeQuestionGroup)="removeQuestionGroup($event)"></app-question-group>

        <app-question-group *ngSwitchCase="'en-US'" [version]="version" [group]="question"
          [questionTypeConfigs]="version?.questionTypeConfigs" [language]="'en-US'"
          [groupsSelectItems]="groupsSelectItems" (addQuestion)="addQuestion($event)"
          (changeGroupFromQuestion)="groupFromQuestionChanged($event)" (moveUpGroup)="moveUpGroup($event)"
          (moveDownGroup)="moveDownGroup($event)"
          (removeQuestionGroup)="removeQuestionGroup($event)"></app-question-group>

        <app-question-group *ngSwitchCase="'es-ES'" [version]="version" [group]="question"
          [questionTypeConfigs]="version?.questionTypeConfigs" [language]="'es-ES'"
          [groupsSelectItems]="groupsSelectItems" (addQuestion)="addQuestion($event)"
          (changeGroupFromQuestion)="groupFromQuestionChanged($event)" (moveUpGroup)="moveUpGroup($event)"
          (moveDownGroup)="moveDownGroup($event)"
          (removeQuestionGroup)="removeQuestionGroup($event)"></app-question-group>
      </ng-container>
    </ng-container>
  </div>

  <div class="container-question-groups" *ngIf="managerQuestionGroupsSelected">
    <ng-container *ngFor="let question of version?.managerQuestionGroups">
      <ng-container [ngSwitch]="selectedLanguage">
        <app-question-group *ngSwitchCase="'pt-BR'" [version]="version" [isManagerGroup]="true" [group]="question"
          [questionTypeConfigs]="version?.questionTypeConfigs" [language]="'pt-BR'"
          [groupsSelectItems]="managerGroupsSelectItems" (addQuestion)="addQuestion($event)"
          (changeGroupFromQuestion)="groupFromQuestionChanged($event)" (moveUpGroup)="moveUpGroup($event)"
          (moveDownGroup)="moveDownGroup($event)"
          (removeQuestionGroup)="removeQuestionGroup($event)"></app-question-group>

        <app-question-group *ngSwitchCase="'en-US'" [version]="version" [isManagerGroup]="true" [group]="question"
          [questionTypeConfigs]="version?.questionTypeConfigs" [language]="'en-US'"
          [groupsSelectItems]="managerGroupsSelectItems" (addQuestion)="addQuestion($event)"
          (changeGroupFromQuestion)="groupFromQuestionChanged($event)" (moveUpGroup)="moveUpGroup($event)"
          (moveDownGroup)="moveDownGroup($event)"
          (removeQuestionGroup)="removeQuestionGroup($event)"></app-question-group>

        <app-question-group *ngSwitchCase="'es-ES'" [version]="version" [group]="question"
          [questionTypeConfigs]="version?.questionTypeConfigs" [isManagerGroup]="true" [language]="'es-ES'"
          [groupsSelectItems]="managerGroupsSelectItems" (addQuestion)="addQuestion($event)"
          (changeGroupFromQuestion)="groupFromQuestionChanged($event)" (moveUpGroup)="moveUpGroup($event)"
          (moveDownGroup)="moveDownGroup($event)"
          (removeQuestionGroup)="removeQuestionGroup($event)"></app-question-group>
      </ng-container>
    </ng-container>
  </div>
</div>